var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.725,
    cy: 13.2148,
    r: 12.7595,
    stroke: "white",
    strokeWidth: 0.911392
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93945 9.99963C9.38745 9.99963 8.93945 9.55163 8.93945 8.99963C8.93945 8.44763 9.38745 7.99963 9.93945 7.99963C10.4915 7.99963 10.9395 8.44763 10.9395 8.99963C10.9395 9.55163 10.4915 9.99963 9.93945 9.99963ZM9.93945 6.99963C8.83495 6.99963 7.93945 7.89513 7.93945 8.99963C7.93945 10.1041 8.83495 10.9996 9.93945 10.9996C11.044 10.9996 11.9395 10.1041 11.9395 8.99963C11.9395 7.89513 11.044 6.99963 9.93945 6.99963ZM20.9395 13.5636L17.9395 10.4996L12.9689 15.5551L10.9395 13.4996L6.93945 17.1681V6.99963C6.93945 6.44763 7.38745 5.99963 7.93945 5.99963H19.9395C20.4915 5.99963 20.9395 6.44763 20.9395 6.99963V13.5636ZM20.9395 18.9996C20.9395 19.5516 20.4915 19.9996 19.9395 19.9996H17.3555L13.6714 16.2671L17.9395 11.9991L20.9395 14.9991V18.9996ZM7.93945 19.9996C7.38745 19.9996 6.93945 19.5516 6.93945 18.9996V18.5301L10.912 14.9721L15.94 19.9996H7.93945ZM19.9395 4.99963H7.93945C6.83495 4.99963 5.93945 5.89513 5.93945 6.99963V18.9996C5.93945 20.1041 6.83495 20.9996 7.93945 20.9996H19.9395C21.044 20.9996 21.9395 20.1041 21.9395 18.9996V6.99963C21.9395 5.89513 21.044 4.99963 19.9395 4.99963Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageCircle);
export default __webpack_public_path__ + "static/media/image-circle.da75eb5618b62d7ad923af6367c3099e.svg";
export { ForwardRef as ReactComponent };